import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, CheckboxComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  templateUrl: './immutability-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    FormsModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    CheckboxComponent,
    ModalFooterDirective
  ]
})
export class ImmutabilityConfirmModalComponent implements OnInit {
  public isStorageWizard: boolean;
  public confirmed = false;
  public readonly MbsPopupType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit(): void {
    this.isStorageWizard = this.baseModal.data?.isStorageWizard;
  }

  confirmClickHandler(): void {
    if (this.confirmed) this.baseModal.save({ confirm: true });
    this.confirmed = false;
  }

  cancelClickHandler(): void {
    this.baseModal.close();
    this.confirmed = false;
  }
}
